export enum ApprovalPanelTypes {
  USER_APPROVAL = 'USER_APPROVAL',
  APPROVAL_HISTORY = 'APPROVAL_HISTORY',
}
